import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  container: {
    fill: '#adadad',
    cursor: 'pointer'
  },
  noOrders: {
    fill: '#efefef',
    cursor: 'auto'
  },
  badgeContainer: {
    position: 'absolute',
    left: 28,
    marginTop: 3,
    background: 'red',
    color: '#fff',
    borderRadius: '50%',
    border: '2px solid #fff',
    width: 15,
    height: 15,
    letterSpacing: 0,
    fontWeight: 900,
    fontSize: 10,
    fontFamily: 'verdana',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  badgeContainerNoOrders: {
    background: '#efefef'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/NavigationBar/Attest/styles.js